import request from '../request'
import axios from 'axios'

// 创建无认证的请求实例，用于公众号接口
const publicRequest = async (url, params = {}, method = 'post') => {
  try {
    // 方法1: 尝试使用原有的request函数（可能需要登录）
    console.log('尝试方法1: 使用原有request函数')
    try {
      const result = await request(url, params, method)
      console.log('方法1成功:', result)
      return { code: 200, result: result, message: '' }
    } catch (error) {
      console.log('方法1失败:', error)
    }

    // 方法2: 直接使用axios，不带任何认证头
    console.log('尝试方法2: 直接axios调用')
    const axiosConfig = {
      url: url,
      method: method,
      baseURL: '/',
      timeout: 30000,
      headers: {
        'Content-Type': method.toLowerCase() === 'get' 
          ? 'application/x-www-form-urlencoded;charset=UTF-8'
          : 'application/json;charset=UTF-8'
      }
    }

    if (method.toLowerCase() === 'get') {
      axiosConfig.params = params
    } else {
      axiosConfig.data = JSON.stringify(params)
    }

    const response = await axios(axiosConfig)
    console.log('方法2成功:', response.data)
    return response.data

  } catch (error) {
    console.error('所有方法都失败:', error)
    throw error
  }
}

/**
 * 新闻相关API接口
 */

/**
 * 获取动态新闻列表
 * @param {Object} params - 请求参数
 * @param {number} params.page - 页数 (可选)
 * @param {number} params.limit - 条数 (可选)
 * @returns {Promise} 返回新闻列表数据
 */
export const getAlphaNewsList = (params = {}) => {
  return request('/api/Alphanews/getAlphaList', params, 'get')
}

/**
 * 获取历史AI新闻列表
 * @param {Object} params - 请求参数
 * @param {string} params.history_date - 日期 (格式: YYYY-MM-DD, 可选)
 * @param {string} params.tag - 关键词搜索 (可选)
 * @param {string} params.category_id - 专业分类ID (可选)
 * @param {number} params.page - 页数 (默认1)
 * @param {number} params.limit - 条数 (默认20)
 * @returns {Promise} 返回历史新闻列表数据
 */
export const getHistoryAiNewsList = (params = {}) => {
  return request('/api/Ainews/getHistoryAiNewsList', params, 'get')
}

/**
 * 获取公众号一级分类标签列表（尝试POST方法）
 * @returns {Promise} 返回一级分类列表数据
 */
export const getOfficialAccountLabelList = () => {
  return publicRequest('/api/Officialaccount/labelList', {}, 'post')
}

/**
 * 获取公众号二级分类列表（尝试POST方法）
 * @param {Object} params - 请求参数
 * @param {number} params.labelId - 一级分类ID (可选)
 * @returns {Promise} 返回二级分类列表数据
 */
export const getOfficialAccountCategoryList = (params = {}) => {
  return publicRequest('/api/Officialaccount/categoryList', params, 'post')
}

/**
 * 获取公众号列表（尝试POST方法）
 * @param {Object} params - 请求参数
 * @param {number} params.categoryId - 二级分类ID (可选)
 * @param {number} params.labelId - 一级分类ID (可选)
 * @param {number} params.page - 页码 (默认1)
 * @param {number} params.limit - 每页条数 (默认100)
 * @returns {Promise} 返回公众号列表数据
 */
export const getOfficialAccountList = (params = {}) => {
  return publicRequest('/api/Officialaccount/officialaccountList', params, 'post')
}

/**
 * 获取好文推荐列表
 * @param {Object} params - 请求参数
 * @param {number} params.page - 页数 (默认1)
 * @param {number} params.limit - 条数 (默认10)
 * @param {string} params.search - 标题搜索 (可选)
 * @returns {Promise} 返回好文推荐列表数据
 */
export const getGoodArticleList = (params = {}) => {
  return request('/api/Wechatarticle/getCommonGoodArticleList', params, 'get')
}

/**
 * 获取关键词时间轴数据
 * @param {Object} params - 请求参数
 * @param {number} params.book_keywords_id - 词条ID (必填)
 * @returns {Promise} 返回关键词时间轴数据
 */
export const getBookKeywordsTimeline = (params = {}) => {
  return request('/api/Ainews/getBookKeywordsTimeline', params, 'get')
}

export default {
  getAlphaNewsList,
  getHistoryAiNewsList,
  getOfficialAccountLabelList,
  getOfficialAccountCategoryList,
  getOfficialAccountList,
  getGoodArticleList,
  getBookKeywordsTimeline
}
